"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientApplications = getClientApplications;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var REQUEST_API_ACCESS_LIMIT = 200;
function createPagesMerger(_ref) {
  var limit = _ref.limit,
    callback = _ref.callback,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset;
  return /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var result, currentOffset, page;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          result = [];
          currentOffset = offset;
          page = null;
        case 3:
          _context.next = 5;
          return callback({
            offset: currentOffset,
            limit: limit
          });
        case 5:
          page = _context.sent;
          result.push.apply(result, (0, _toConsumableArray2.default)(page));
          currentOffset += page.length;
        case 8:
          if (page.length === limit) {
            _context.next = 3;
            break;
          }
        case 9:
          return _context.abrupt("return", result);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function getClientApplications(_x) {
  return _getClientApplications.apply(this, arguments);
}
function _getClientApplications() {
  _getClientApplications = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(params) {
    var applicationService, fetchApplicationList, applicationsList;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          applicationService = new _exchangeApiClient.ApplicationService(params.config);
          fetchApplicationList = createPagesMerger({
            limit: REQUEST_API_ACCESS_LIMIT,
            callback: function callback(_ref3) {
              var offset = _ref3.offset,
                limit = _ref3.limit;
              return applicationService.list(_objectSpread(_objectSpread({}, params), {}, {
                offset: offset,
                limit: limit
              }));
            }
          });
          _context2.next = 4;
          return fetchApplicationList();
        case 4:
          applicationsList = _context2.sent;
          return _context2.abrupt("return", applicationsList);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getClientApplications.apply(this, arguments);
}
//# sourceMappingURL=utils.js.map